import React from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import {CellTextORNAFormatter} from "../../components";


const getRowStyle = (item) => {
  const style = {}
  if (item.consumed) {
    style.borderLeft = '10px solid Orange'
    return style
  }
  if (item.blocked) {
    style.borderLeft = '10px solid Red'
    return style
  }
  style.borderLeft = '10px solid Green'
  return style
}
export const RepairInventoryStatsDataGrid = ({
  results,
  page_size,
  current,
  count,
  onFilter,
  handleTableChange,
  children,
  hiddenRowKeys,
  inventoryType
}) => {

  const columns = [
    {
      dataField: 'organization_code',
      searchFieldKey: 'organization',
      text: 'Organization',
      type: 'string'
    },
    {
      dataField: 'part_number',
      text: 'Part Number',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'description',
      text: 'Description',
      type: 'string',
      formatter: components.CellTextFormatter,
    },
    {
      dataField: 'total_count',
      text: 'Total count',
      type: 'string',
      formatter: components.CellTextFormatter,
    },
     {
      dataField: 'apple',
      text: 'Apple',
      type: 'string',
      formatter: components.CellTextORNAFormatter,
    },
     {
      dataField: 'unicorn',
      text: 'Unicorn',
      type: 'string',
      formatter: components.CellTextORNAFormatter,
    },
       {
      dataField: 'consumed',
      text: 'Total Consumed',
      type: 'string',
      formatter: components.CellTextFormatter,
    },
       {
      dataField: 'available',
      text: 'Total available',
      type: 'string',
      formatter: components.CellTextFormatter,
    },

  ]
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>{inventoryType.replace(/^./, str => str.toUpperCase())} Inventory Stats</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-white text-end" xs={6}>
            <components.Slider
              size="sm"
              title={components.ICONS.SEARCH}
              sliderWidth={"20vw"}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-3"> Repair Inventory</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>

            {children}
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <components.DataGrid
          rowStyle={getRowStyle}
          keyField="url"
          data={results || []}
          sizePerPage={page_size || 10}
          current={current || 1}
          page={current}
          columns={columns}
          count={count || 0}
          onTableChange={handleTableChange}
          hiddenRows={hiddenRowKeys}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
